// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppEntitlementSearchService } from "./app_entitlement";
import type { SearchGrantsExpiringBeforeResponse } from "./app_entitlement";
import type { SearchGrantsExpiringBeforeRequest } from "./app_entitlement";
import type { CountGrantsExpiringBeforeResponse } from "./app_entitlement";
import type { CountGrantsExpiringBeforeRequest } from "./app_entitlement";
import type { SearchAppEntitlementCorrelationForAccessProfileResponse } from "./app_entitlement";
import type { SearchAppEntitlementCorrelationForAccessProfileRequest } from "./app_entitlement";
import type { SearchAppEntitlementUserBindingSourcesResponse } from "./app_entitlement";
import type { SearchAppEntitlementUserBindingSourcesRequest } from "./app_entitlement";
import type { SearchAppEntitlementUserBindingDestinationsResponse } from "./app_entitlement";
import type { SearchAppEntitlementUserBindingDestinationsRequest } from "./app_entitlement";
import type { RollupEntitlementsWithGrantsResponse } from "./app_entitlement";
import type { RollupEntitlementsWithGrantsRequest } from "./app_entitlement";
import type { SearchRequestableEntitlementsForUserResponse } from "./app_entitlement";
import type { SearchRequestableEntitlementsForUserRequest } from "./app_entitlement";
import type { SearchAppEntitlementsForAppUserRequest } from "./app_entitlement";
import type { SearchAppEntitlementsWithRevokableForAppUserResponse } from "./app_entitlement";
import type { SearchAppEntitlementsWithRevokableForAppUserRequest } from "./app_entitlement";
import type { SearchAppEntitlementsWithDeactivatedOwnerResponse } from "./app_entitlement";
import type { SearchAppEntitlementsWithDeactivatedOwnerRequest } from "./app_entitlement";
import type { SearchAppEntitlementsWithOneOwnerResponse } from "./app_entitlement";
import type { SearchAppEntitlementsWithOneOwnerRequest } from "./app_entitlement";
import type { AppEntitlementSearchServiceCountAncestorsResponse } from "./app_entitlement";
import type { AppEntitlementSearchServiceCountAncestorsRequest } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchAncestorsResponse } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchAncestorsRequest } from "./app_entitlement";
import type { SearchStandingHighRiskGrantsForAppsResponse } from "./app_entitlement";
import type { SearchStandingHighRiskGrantsForAppsRequest } from "./app_entitlement";
import type { CountStandingHighRiskGrantsResponse } from "./app_entitlement";
import type { CountStandingHighRiskGrantsRequest } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchGrantsResponse } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchGrantsRequest } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchExpiringAccessForUserResponse } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchExpiringAccessForUserRequest } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchCountResponse } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchCountRequest } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchTermsResponse } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchTermsRequest } from "./app_entitlement";
import type { GetAccessProfilesForGrantsResponse } from "./app_entitlement";
import type { GetAccessProfilesForGrantsRequest } from "./app_entitlement";
import type { SearchAppEntitlementsWithExpiredResponse } from "./app_entitlement";
import type { SearchAppEntitlementsWithExpiredRequest } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchResponse } from "./app_entitlement";
import type { AppEntitlementSearchServiceSearchRequest } from "./app_entitlement";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppEntitlements } from "./app_entitlement";
import type { ForceRunDynamicGroupAutomationResponse } from "./app_entitlement";
import type { ForceRunDynamicGroupAutomationRequest } from "./app_entitlement";
import type { RemoveEntitlementMembershipResponse } from "./app_entitlement";
import type { RemoveEntitlementMembershipRequest } from "./app_entitlement";
import type { ManuallyManagedUsersResponse } from "./app_entitlement";
import type { AddManuallyManagedUsersRequest } from "./app_entitlement";
import type { ListAutomationExclusionsResponse } from "./app_entitlement";
import type { ListAutomationExclusionsRequest } from "./app_entitlement";
import type { RemoveAutomationExclusionResponse } from "./app_entitlement";
import type { RemoveAutomationExclusionRequest } from "./app_entitlement";
import type { AddAutomationExclusionResponse } from "./app_entitlement";
import type { AddAutomationExclusionRequest } from "./app_entitlement";
import type { AppEntitlementServiceUpdateAutomationResponse } from "./app_entitlement";
import type { AppEntitlementServiceUpdateAutomationRequest } from "./app_entitlement";
import type { AppEntitlementServicePreviewAutomationCELResponse } from "./app_entitlement";
import type { AppEntitlementServicePreviewAutomationCELRequest } from "./app_entitlement";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { AppEntitlementServiceGetAutomationResponse } from "./app_entitlement";
import type { AppEntitlementServiceGetAutomationRequest } from "./app_entitlement";
import type { DeleteAutomationResponse } from "./app_entitlement";
import type { DeleteAutomationRequest } from "./app_entitlement";
import type { CreateAutomationResponse } from "./app_entitlement";
import type { CreateAutomationRequest } from "./app_entitlement";
import type { Empty } from "../../../../google/protobuf/empty";
import type { DeleteAppEntitlementIfManuallyCreatedRequest } from "./app_entitlement";
import type { DeleteAppEntitlementResponse } from "./app_entitlement";
import type { DeleteAppEntitlementRequest } from "./app_entitlement";
import type { UpdateAppEntitlementRequest } from "./app_entitlement";
import type { UpdateDeprovisionerPolicyAppEntitlementRequest } from "./app_entitlement";
import type { UpdateAppEntitlementResponse } from "./app_entitlement";
import type { UpdateProvisionerPolicyAppEntitlementRequest } from "./app_entitlement";
import type { ListAppEntitlementsForAppResourceRequest } from "./app_entitlement";
import type { ListAppEntitlementsForAppUserRequest } from "./app_entitlement";
import type { ListAppEntitlementUsersResponse } from "./app_entitlement";
import type { ListAppEntitlementUsersRequest } from "./app_entitlement";
import type { ListAppEntitlementsResponse } from "./app_entitlement";
import type { ListAppEntitlementsRequest } from "./app_entitlement";
import type { BulkGetAppEntitlementsResponse } from "./app_entitlement";
import type { BulkGetAppEntitlementsRequest } from "./app_entitlement";
import type { GetAppEntitlementResponse } from "./app_entitlement";
import type { GetAppEntitlementRequest } from "./app_entitlement";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateAppEntitlementResponse } from "./app_entitlement";
import type { CreateAppEntitlementRequest } from "./app_entitlement";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlements
 */
export interface IAppEntitlementsClient {
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: CreateAppEntitlementRequest, options?: RpcOptions): UnaryCall<CreateAppEntitlementRequest, CreateAppEntitlementResponse>;
    /**
     * Get an app entitlement by ID.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: GetAppEntitlementRequest, options?: RpcOptions): UnaryCall<GetAppEntitlementRequest, GetAppEntitlementResponse>;
    /**
     * Bulk get app entitlements by refs.
     *
     * @generated from protobuf rpc: BulkGet
     */
    bulkGet(input: BulkGetAppEntitlementsRequest, options?: RpcOptions): UnaryCall<BulkGetAppEntitlementsRequest, BulkGetAppEntitlementsResponse>;
    /**
     * List app entitlements associated with an app.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListAppEntitlementsRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementsRequest, ListAppEntitlementsResponse>;
    /**
     * List the users, as AppEntitlementUsers objects, of an app entitlement.
     *
     * @deprecated
     * @generated from protobuf rpc: ListUsers
     */
    listUsers(input: ListAppEntitlementUsersRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementUsersRequest, ListAppEntitlementUsersResponse>;
    /**
     * List app entitlements associated with an app user.
     *
     * @generated from protobuf rpc: ListForAppUser
     */
    listForAppUser(input: ListAppEntitlementsForAppUserRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementsForAppUserRequest, ListAppEntitlementsResponse>;
    /**
     * List app entitlements associated with an app resource.
     *
     * @generated from protobuf rpc: ListForAppResource
     */
    listForAppResource(input: ListAppEntitlementsForAppResourceRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementsForAppResourceRequest, ListAppEntitlementsResponse>;
    /**
     * Update the provisioner policy for an app entitlement.
     *
     * @generated from protobuf rpc: UpdateProvisionerPolicy
     */
    updateProvisionerPolicy(input: UpdateProvisionerPolicyAppEntitlementRequest, options?: RpcOptions): UnaryCall<UpdateProvisionerPolicyAppEntitlementRequest, UpdateAppEntitlementResponse>;
    /**
     * @generated from protobuf rpc: UpdateDeprovisionerPolicy
     */
    updateDeprovisionerPolicy(input: UpdateDeprovisionerPolicyAppEntitlementRequest, options?: RpcOptions): UnaryCall<UpdateDeprovisionerPolicyAppEntitlementRequest, UpdateAppEntitlementResponse>;
    /**
     * Update an app entitlement by ID.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: UpdateAppEntitlementRequest, options?: RpcOptions): UnaryCall<UpdateAppEntitlementRequest, UpdateAppEntitlementResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteAppEntitlementRequest, options?: RpcOptions): UnaryCall<DeleteAppEntitlementRequest, DeleteAppEntitlementResponse>;
    /**
     * @generated from protobuf rpc: DeleteIfManuallyCreated
     */
    deleteIfManuallyCreated(input: DeleteAppEntitlementIfManuallyCreatedRequest, options?: RpcOptions): UnaryCall<DeleteAppEntitlementIfManuallyCreatedRequest, Empty>;
    /**
     * @generated from protobuf rpc: CreateAutomation
     */
    createAutomation(input: CreateAutomationRequest, options?: RpcOptions): UnaryCall<CreateAutomationRequest, CreateAutomationResponse>;
    /**
     * @generated from protobuf rpc: DeleteAutomation
     */
    deleteAutomation(input: DeleteAutomationRequest, options?: RpcOptions): UnaryCall<DeleteAutomationRequest, DeleteAutomationResponse>;
    /**
     * @generated from protobuf rpc: GetAutomation
     */
    getAutomation(input: AppEntitlementServiceGetAutomationRequest, options?: RpcOptions): UnaryCall<AppEntitlementServiceGetAutomationRequest, AppEntitlementServiceGetAutomationResponse>;
    /**
     * @generated from protobuf rpc: PreviewAutomationCEL
     */
    previewAutomationCEL(input: AppEntitlementServicePreviewAutomationCELRequest, options?: RpcOptions): ServerStreamingCall<AppEntitlementServicePreviewAutomationCELRequest, AppEntitlementServicePreviewAutomationCELResponse>;
    /**
     * @generated from protobuf rpc: UpdateAutomation
     */
    updateAutomation(input: AppEntitlementServiceUpdateAutomationRequest, options?: RpcOptions): UnaryCall<AppEntitlementServiceUpdateAutomationRequest, AppEntitlementServiceUpdateAutomationResponse>;
    /**
     * @generated from protobuf rpc: AddAutomationExclusion
     */
    addAutomationExclusion(input: AddAutomationExclusionRequest, options?: RpcOptions): UnaryCall<AddAutomationExclusionRequest, AddAutomationExclusionResponse>;
    /**
     * @generated from protobuf rpc: RemoveAutomationExclusion
     */
    removeAutomationExclusion(input: RemoveAutomationExclusionRequest, options?: RpcOptions): UnaryCall<RemoveAutomationExclusionRequest, RemoveAutomationExclusionResponse>;
    /**
     * @generated from protobuf rpc: ListAutomationExclusions
     */
    listAutomationExclusions(input: ListAutomationExclusionsRequest, options?: RpcOptions): UnaryCall<ListAutomationExclusionsRequest, ListAutomationExclusionsResponse>;
    /**
     * @generated from protobuf rpc: AddManuallyManagedMembers
     */
    addManuallyManagedMembers(input: AddManuallyManagedUsersRequest, options?: RpcOptions): UnaryCall<AddManuallyManagedUsersRequest, ManuallyManagedUsersResponse>;
    /**
     * @generated from protobuf rpc: RemoveEntitlementMembership
     */
    removeEntitlementMembership(input: RemoveEntitlementMembershipRequest, options?: RpcOptions): UnaryCall<RemoveEntitlementMembershipRequest, RemoveEntitlementMembershipResponse>;
    /**
     * @generated from protobuf rpc: ForceRunDynamicGroupAutomation
     */
    forceRunDynamicGroupAutomation(input: ForceRunDynamicGroupAutomationRequest, options?: RpcOptions): UnaryCall<ForceRunDynamicGroupAutomationRequest, ForceRunDynamicGroupAutomationResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlements
 */
export class AppEntitlementsClient implements IAppEntitlementsClient, ServiceInfo {
    typeName = AppEntitlements.typeName;
    methods = AppEntitlements.methods;
    options = AppEntitlements.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: CreateAppEntitlementRequest, options?: RpcOptions): UnaryCall<CreateAppEntitlementRequest, CreateAppEntitlementResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAppEntitlementRequest, CreateAppEntitlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get an app entitlement by ID.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: GetAppEntitlementRequest, options?: RpcOptions): UnaryCall<GetAppEntitlementRequest, GetAppEntitlementResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppEntitlementRequest, GetAppEntitlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Bulk get app entitlements by refs.
     *
     * @generated from protobuf rpc: BulkGet
     */
    bulkGet(input: BulkGetAppEntitlementsRequest, options?: RpcOptions): UnaryCall<BulkGetAppEntitlementsRequest, BulkGetAppEntitlementsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkGetAppEntitlementsRequest, BulkGetAppEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List app entitlements associated with an app.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListAppEntitlementsRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementsRequest, ListAppEntitlementsResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppEntitlementsRequest, ListAppEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List the users, as AppEntitlementUsers objects, of an app entitlement.
     *
     * @deprecated
     * @generated from protobuf rpc: ListUsers
     */
    listUsers(input: ListAppEntitlementUsersRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementUsersRequest, ListAppEntitlementUsersResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppEntitlementUsersRequest, ListAppEntitlementUsersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List app entitlements associated with an app user.
     *
     * @generated from protobuf rpc: ListForAppUser
     */
    listForAppUser(input: ListAppEntitlementsForAppUserRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementsForAppUserRequest, ListAppEntitlementsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppEntitlementsForAppUserRequest, ListAppEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List app entitlements associated with an app resource.
     *
     * @generated from protobuf rpc: ListForAppResource
     */
    listForAppResource(input: ListAppEntitlementsForAppResourceRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementsForAppResourceRequest, ListAppEntitlementsResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppEntitlementsForAppResourceRequest, ListAppEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update the provisioner policy for an app entitlement.
     *
     * @generated from protobuf rpc: UpdateProvisionerPolicy
     */
    updateProvisionerPolicy(input: UpdateProvisionerPolicyAppEntitlementRequest, options?: RpcOptions): UnaryCall<UpdateProvisionerPolicyAppEntitlementRequest, UpdateAppEntitlementResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateProvisionerPolicyAppEntitlementRequest, UpdateAppEntitlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateDeprovisionerPolicy
     */
    updateDeprovisionerPolicy(input: UpdateDeprovisionerPolicyAppEntitlementRequest, options?: RpcOptions): UnaryCall<UpdateDeprovisionerPolicyAppEntitlementRequest, UpdateAppEntitlementResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateDeprovisionerPolicyAppEntitlementRequest, UpdateAppEntitlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update an app entitlement by ID.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: UpdateAppEntitlementRequest, options?: RpcOptions): UnaryCall<UpdateAppEntitlementRequest, UpdateAppEntitlementResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAppEntitlementRequest, UpdateAppEntitlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteAppEntitlementRequest, options?: RpcOptions): UnaryCall<DeleteAppEntitlementRequest, DeleteAppEntitlementResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAppEntitlementRequest, DeleteAppEntitlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteIfManuallyCreated
     */
    deleteIfManuallyCreated(input: DeleteAppEntitlementIfManuallyCreatedRequest, options?: RpcOptions): UnaryCall<DeleteAppEntitlementIfManuallyCreatedRequest, Empty> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAppEntitlementIfManuallyCreatedRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateAutomation
     */
    createAutomation(input: CreateAutomationRequest, options?: RpcOptions): UnaryCall<CreateAutomationRequest, CreateAutomationResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAutomationRequest, CreateAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteAutomation
     */
    deleteAutomation(input: DeleteAutomationRequest, options?: RpcOptions): UnaryCall<DeleteAutomationRequest, DeleteAutomationResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAutomationRequest, DeleteAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAutomation
     */
    getAutomation(input: AppEntitlementServiceGetAutomationRequest, options?: RpcOptions): UnaryCall<AppEntitlementServiceGetAutomationRequest, AppEntitlementServiceGetAutomationResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementServiceGetAutomationRequest, AppEntitlementServiceGetAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PreviewAutomationCEL
     */
    previewAutomationCEL(input: AppEntitlementServicePreviewAutomationCELRequest, options?: RpcOptions): ServerStreamingCall<AppEntitlementServicePreviewAutomationCELRequest, AppEntitlementServicePreviewAutomationCELResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementServicePreviewAutomationCELRequest, AppEntitlementServicePreviewAutomationCELResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateAutomation
     */
    updateAutomation(input: AppEntitlementServiceUpdateAutomationRequest, options?: RpcOptions): UnaryCall<AppEntitlementServiceUpdateAutomationRequest, AppEntitlementServiceUpdateAutomationResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementServiceUpdateAutomationRequest, AppEntitlementServiceUpdateAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddAutomationExclusion
     */
    addAutomationExclusion(input: AddAutomationExclusionRequest, options?: RpcOptions): UnaryCall<AddAutomationExclusionRequest, AddAutomationExclusionResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddAutomationExclusionRequest, AddAutomationExclusionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveAutomationExclusion
     */
    removeAutomationExclusion(input: RemoveAutomationExclusionRequest, options?: RpcOptions): UnaryCall<RemoveAutomationExclusionRequest, RemoveAutomationExclusionResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveAutomationExclusionRequest, RemoveAutomationExclusionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAutomationExclusions
     */
    listAutomationExclusions(input: ListAutomationExclusionsRequest, options?: RpcOptions): UnaryCall<ListAutomationExclusionsRequest, ListAutomationExclusionsResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAutomationExclusionsRequest, ListAutomationExclusionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddManuallyManagedMembers
     */
    addManuallyManagedMembers(input: AddManuallyManagedUsersRequest, options?: RpcOptions): UnaryCall<AddManuallyManagedUsersRequest, ManuallyManagedUsersResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddManuallyManagedUsersRequest, ManuallyManagedUsersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveEntitlementMembership
     */
    removeEntitlementMembership(input: RemoveEntitlementMembershipRequest, options?: RpcOptions): UnaryCall<RemoveEntitlementMembershipRequest, RemoveEntitlementMembershipResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveEntitlementMembershipRequest, RemoveEntitlementMembershipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ForceRunDynamicGroupAutomation
     */
    forceRunDynamicGroupAutomation(input: ForceRunDynamicGroupAutomationRequest, options?: RpcOptions): UnaryCall<ForceRunDynamicGroupAutomationRequest, ForceRunDynamicGroupAutomationResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<ForceRunDynamicGroupAutomationRequest, ForceRunDynamicGroupAutomationResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlementSearchService
 */
export interface IAppEntitlementSearchServiceClient {
    /**
     * Search app entitlements based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search
     */
    search(input: AppEntitlementSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchRequest, AppEntitlementSearchServiceSearchResponse>;
    /**
     * Search app entitlements, include app users, users, expires, discovered.
     *
     * @generated from protobuf rpc: SearchAppEntitlementsWithExpired
     */
    searchAppEntitlementsWithExpired(input: SearchAppEntitlementsWithExpiredRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithExpiredRequest, SearchAppEntitlementsWithExpiredResponse>;
    /**
     * Get access profiles (catalogs) that contain the given entitlement and for which the given app users have membership.
     * Returns the access profiles along with their membership expiry times, grouped by user.
     *
     * @generated from protobuf rpc: GetAccessProfilesForGrants
     */
    getAccessProfilesForGrants(input: GetAccessProfilesForGrantsRequest, options?: RpcOptions): UnaryCall<GetAccessProfilesForGrantsRequest, GetAccessProfilesForGrantsResponse>;
    /**
     * @generated from protobuf rpc: GetSearchTerms
     */
    getSearchTerms(input: AppEntitlementSearchServiceSearchTermsRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchTermsRequest, AppEntitlementSearchServiceSearchTermsResponse>;
    /**
     * @generated from protobuf rpc: SearchCount
     */
    searchCount(input: AppEntitlementSearchServiceSearchCountRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchCountRequest, AppEntitlementSearchServiceSearchCountResponse>;
    /**
     * @generated from protobuf rpc: SearchExpiringAccessForUser
     */
    searchExpiringAccessForUser(input: AppEntitlementSearchServiceSearchExpiringAccessForUserRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchExpiringAccessForUserRequest, AppEntitlementSearchServiceSearchExpiringAccessForUserResponse>;
    /**
     * @generated from protobuf rpc: SearchGrants
     */
    searchGrants(input: AppEntitlementSearchServiceSearchGrantsRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchGrantsRequest, AppEntitlementSearchServiceSearchGrantsResponse>;
    /**
     * @generated from protobuf rpc: SearchExpiringAccessForUserCount
     */
    searchExpiringAccessForUserCount(input: AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest, AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse>;
    /**
     * @generated from protobuf rpc: CountStandingHighRiskGrants
     */
    countStandingHighRiskGrants(input: CountStandingHighRiskGrantsRequest, options?: RpcOptions): UnaryCall<CountStandingHighRiskGrantsRequest, CountStandingHighRiskGrantsResponse>;
    /**
     * @generated from protobuf rpc: SearchStandingHighRiskGrantsForApps
     */
    searchStandingHighRiskGrantsForApps(input: SearchStandingHighRiskGrantsForAppsRequest, options?: RpcOptions): UnaryCall<SearchStandingHighRiskGrantsForAppsRequest, SearchStandingHighRiskGrantsForAppsResponse>;
    /**
     * @generated from protobuf rpc: SearchAncestors
     */
    searchAncestors(input: AppEntitlementSearchServiceSearchAncestorsRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchAncestorsRequest, AppEntitlementSearchServiceSearchAncestorsResponse>;
    /**
     * @generated from protobuf rpc: CountAncestors
     */
    countAncestors(input: AppEntitlementSearchServiceCountAncestorsRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceCountAncestorsRequest, AppEntitlementSearchServiceCountAncestorsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsWithOneOwner
     */
    searchAppEntitlementsWithOneOwner(input: SearchAppEntitlementsWithOneOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithOneOwnerRequest, SearchAppEntitlementsWithOneOwnerResponse>;
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsWithDeactivatedOwner
     */
    searchAppEntitlementsWithDeactivatedOwner(input: SearchAppEntitlementsWithDeactivatedOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithDeactivatedOwnerRequest, SearchAppEntitlementsWithDeactivatedOwnerResponse>;
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsWithRevokableForAppUser
     */
    searchAppEntitlementsWithRevokableForAppUser(input: SearchAppEntitlementsWithRevokableForAppUserRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithRevokableForAppUserRequest, SearchAppEntitlementsWithRevokableForAppUserResponse>;
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsForAppUser
     */
    searchAppEntitlementsForAppUser(input: SearchAppEntitlementsForAppUserRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsForAppUserRequest, ListAppEntitlementsResponse>;
    /**
     * Searches for requestable entitlements given a C1 User ID. Returns an entitlement/task/grant - showing if the user has access, expiring access, or a pending request.
     *
     * @generated from protobuf rpc: SearchRequestableEntitlementsForUser
     */
    searchRequestableEntitlementsForUser(input: SearchRequestableEntitlementsForUserRequest, options?: RpcOptions): UnaryCall<SearchRequestableEntitlementsForUserRequest, SearchRequestableEntitlementsForUserResponse>;
    /**
     * Given a list of entitlement IDs, and an App ID, roll up the entitlements with the grants that are associated with them.
     *
     * @generated from protobuf rpc: RollupEntitlementsWithGrants
     */
    rollupEntitlementsWithGrants(input: RollupEntitlementsWithGrantsRequest, options?: RpcOptions): UnaryCall<RollupEntitlementsWithGrantsRequest, RollupEntitlementsWithGrantsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppEntitlementUserBindingDestinations
     */
    searchAppEntitlementUserBindingDestinations(input: SearchAppEntitlementUserBindingDestinationsRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementUserBindingDestinationsRequest, SearchAppEntitlementUserBindingDestinationsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppEntitlementUserBindingSources
     */
    searchAppEntitlementUserBindingSources(input: SearchAppEntitlementUserBindingSourcesRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementUserBindingSourcesRequest, SearchAppEntitlementUserBindingSourcesResponse>;
    /**
     * @generated from protobuf rpc: SearchAppEntitlementCorrelationForAccessProfile
     */
    searchAppEntitlementCorrelationForAccessProfile(input: SearchAppEntitlementCorrelationForAccessProfileRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementCorrelationForAccessProfileRequest, SearchAppEntitlementCorrelationForAccessProfileResponse>;
    /**
     * Count grants expiring before a given time across all users.
     *
     * @generated from protobuf rpc: CountGrantsExpiringBefore
     */
    countGrantsExpiringBefore(input: CountGrantsExpiringBeforeRequest, options?: RpcOptions): UnaryCall<CountGrantsExpiringBeforeRequest, CountGrantsExpiringBeforeResponse>;
    /**
     * Search for grants expiring before a given time across all users.
     *
     * @generated from protobuf rpc: SearchGrantsExpiringBefore
     */
    searchGrantsExpiringBefore(input: SearchGrantsExpiringBeforeRequest, options?: RpcOptions): UnaryCall<SearchGrantsExpiringBeforeRequest, SearchGrantsExpiringBeforeResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlementSearchService
 */
export class AppEntitlementSearchServiceClient implements IAppEntitlementSearchServiceClient, ServiceInfo {
    typeName = AppEntitlementSearchService.typeName;
    methods = AppEntitlementSearchService.methods;
    options = AppEntitlementSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search app entitlements based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search
     */
    search(input: AppEntitlementSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchRequest, AppEntitlementSearchServiceSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementSearchServiceSearchRequest, AppEntitlementSearchServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search app entitlements, include app users, users, expires, discovered.
     *
     * @generated from protobuf rpc: SearchAppEntitlementsWithExpired
     */
    searchAppEntitlementsWithExpired(input: SearchAppEntitlementsWithExpiredRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithExpiredRequest, SearchAppEntitlementsWithExpiredResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementsWithExpiredRequest, SearchAppEntitlementsWithExpiredResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get access profiles (catalogs) that contain the given entitlement and for which the given app users have membership.
     * Returns the access profiles along with their membership expiry times, grouped by user.
     *
     * @generated from protobuf rpc: GetAccessProfilesForGrants
     */
    getAccessProfilesForGrants(input: GetAccessProfilesForGrantsRequest, options?: RpcOptions): UnaryCall<GetAccessProfilesForGrantsRequest, GetAccessProfilesForGrantsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccessProfilesForGrantsRequest, GetAccessProfilesForGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSearchTerms
     */
    getSearchTerms(input: AppEntitlementSearchServiceSearchTermsRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchTermsRequest, AppEntitlementSearchServiceSearchTermsResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementSearchServiceSearchTermsRequest, AppEntitlementSearchServiceSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCount
     */
    searchCount(input: AppEntitlementSearchServiceSearchCountRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchCountRequest, AppEntitlementSearchServiceSearchCountResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementSearchServiceSearchCountRequest, AppEntitlementSearchServiceSearchCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchExpiringAccessForUser
     */
    searchExpiringAccessForUser(input: AppEntitlementSearchServiceSearchExpiringAccessForUserRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchExpiringAccessForUserRequest, AppEntitlementSearchServiceSearchExpiringAccessForUserResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementSearchServiceSearchExpiringAccessForUserRequest, AppEntitlementSearchServiceSearchExpiringAccessForUserResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchGrants
     */
    searchGrants(input: AppEntitlementSearchServiceSearchGrantsRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchGrantsRequest, AppEntitlementSearchServiceSearchGrantsResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementSearchServiceSearchGrantsRequest, AppEntitlementSearchServiceSearchGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchExpiringAccessForUserCount
     */
    searchExpiringAccessForUserCount(input: AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest, AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest, AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountStandingHighRiskGrants
     */
    countStandingHighRiskGrants(input: CountStandingHighRiskGrantsRequest, options?: RpcOptions): UnaryCall<CountStandingHighRiskGrantsRequest, CountStandingHighRiskGrantsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountStandingHighRiskGrantsRequest, CountStandingHighRiskGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchStandingHighRiskGrantsForApps
     */
    searchStandingHighRiskGrantsForApps(input: SearchStandingHighRiskGrantsForAppsRequest, options?: RpcOptions): UnaryCall<SearchStandingHighRiskGrantsForAppsRequest, SearchStandingHighRiskGrantsForAppsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchStandingHighRiskGrantsForAppsRequest, SearchStandingHighRiskGrantsForAppsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAncestors
     */
    searchAncestors(input: AppEntitlementSearchServiceSearchAncestorsRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceSearchAncestorsRequest, AppEntitlementSearchServiceSearchAncestorsResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementSearchServiceSearchAncestorsRequest, AppEntitlementSearchServiceSearchAncestorsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountAncestors
     */
    countAncestors(input: AppEntitlementSearchServiceCountAncestorsRequest, options?: RpcOptions): UnaryCall<AppEntitlementSearchServiceCountAncestorsRequest, AppEntitlementSearchServiceCountAncestorsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppEntitlementSearchServiceCountAncestorsRequest, AppEntitlementSearchServiceCountAncestorsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsWithOneOwner
     */
    searchAppEntitlementsWithOneOwner(input: SearchAppEntitlementsWithOneOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithOneOwnerRequest, SearchAppEntitlementsWithOneOwnerResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementsWithOneOwnerRequest, SearchAppEntitlementsWithOneOwnerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsWithDeactivatedOwner
     */
    searchAppEntitlementsWithDeactivatedOwner(input: SearchAppEntitlementsWithDeactivatedOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithDeactivatedOwnerRequest, SearchAppEntitlementsWithDeactivatedOwnerResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementsWithDeactivatedOwnerRequest, SearchAppEntitlementsWithDeactivatedOwnerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsWithRevokableForAppUser
     */
    searchAppEntitlementsWithRevokableForAppUser(input: SearchAppEntitlementsWithRevokableForAppUserRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsWithRevokableForAppUserRequest, SearchAppEntitlementsWithRevokableForAppUserResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementsWithRevokableForAppUserRequest, SearchAppEntitlementsWithRevokableForAppUserResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementsForAppUser
     */
    searchAppEntitlementsForAppUser(input: SearchAppEntitlementsForAppUserRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementsForAppUserRequest, ListAppEntitlementsResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementsForAppUserRequest, ListAppEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Searches for requestable entitlements given a C1 User ID. Returns an entitlement/task/grant - showing if the user has access, expiring access, or a pending request.
     *
     * @generated from protobuf rpc: SearchRequestableEntitlementsForUser
     */
    searchRequestableEntitlementsForUser(input: SearchRequestableEntitlementsForUserRequest, options?: RpcOptions): UnaryCall<SearchRequestableEntitlementsForUserRequest, SearchRequestableEntitlementsForUserResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchRequestableEntitlementsForUserRequest, SearchRequestableEntitlementsForUserResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Given a list of entitlement IDs, and an App ID, roll up the entitlements with the grants that are associated with them.
     *
     * @generated from protobuf rpc: RollupEntitlementsWithGrants
     */
    rollupEntitlementsWithGrants(input: RollupEntitlementsWithGrantsRequest, options?: RpcOptions): UnaryCall<RollupEntitlementsWithGrantsRequest, RollupEntitlementsWithGrantsResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<RollupEntitlementsWithGrantsRequest, RollupEntitlementsWithGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementUserBindingDestinations
     */
    searchAppEntitlementUserBindingDestinations(input: SearchAppEntitlementUserBindingDestinationsRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementUserBindingDestinationsRequest, SearchAppEntitlementUserBindingDestinationsResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementUserBindingDestinationsRequest, SearchAppEntitlementUserBindingDestinationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementUserBindingSources
     */
    searchAppEntitlementUserBindingSources(input: SearchAppEntitlementUserBindingSourcesRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementUserBindingSourcesRequest, SearchAppEntitlementUserBindingSourcesResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementUserBindingSourcesRequest, SearchAppEntitlementUserBindingSourcesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementCorrelationForAccessProfile
     */
    searchAppEntitlementCorrelationForAccessProfile(input: SearchAppEntitlementCorrelationForAccessProfileRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementCorrelationForAccessProfileRequest, SearchAppEntitlementCorrelationForAccessProfileResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementCorrelationForAccessProfileRequest, SearchAppEntitlementCorrelationForAccessProfileResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Count grants expiring before a given time across all users.
     *
     * @generated from protobuf rpc: CountGrantsExpiringBefore
     */
    countGrantsExpiringBefore(input: CountGrantsExpiringBeforeRequest, options?: RpcOptions): UnaryCall<CountGrantsExpiringBeforeRequest, CountGrantsExpiringBeforeResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountGrantsExpiringBeforeRequest, CountGrantsExpiringBeforeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search for grants expiring before a given time across all users.
     *
     * @generated from protobuf rpc: SearchGrantsExpiringBefore
     */
    searchGrantsExpiringBefore(input: SearchGrantsExpiringBeforeRequest, options?: RpcOptions): UnaryCall<SearchGrantsExpiringBeforeRequest, SearchGrantsExpiringBeforeResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchGrantsExpiringBeforeRequest, SearchGrantsExpiringBeforeResponse>("unary", this._transport, method, opt, input);
    }
}
